export default {
  // Page title
  pageTitle: 'Alert Center',

  // Template business type
  templateBusinessType: {
    registerVerificationCode: 'Registration Verification Code',
    loginVerificationCode: 'Login Verification Code',
    passwordResetVerificationCode: 'Password Reset Verification Code',
    changeEmailMobileCode: 'Identity Verification Code',
    passwordResetNotice: 'Password Reset Notice',
    createUserNotice: 'User Creation Notice',
    demoReservationNotice: 'Demo Reservation Notice',
    aiCustomerLetter: 'AI Customer Development Letter',
    aiCustomerFreight: 'AI Customer Freight Promotion',
    testEmailConfig: 'Test Email Config'
  },

  // Tab labels
  tabs: {
    notificationSubscription: 'Notification Subscription Settings',
    templateSettings: 'Notification Template Settings',
    emailConfig: 'Email Configuration',
    wechatConfig: 'WeCom API Configuration',
    wechatWorkRpa: 'WeCom RPA Configuration',
    sentEmails: 'Sent Emails'
  },

  // Common shared copies
  common: {
    selectAll: 'Select All',
    invertSelect: 'Invert Selection',
    email: 'Email',
    wechat: 'WeCom',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    reset: 'Reset',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    confirm: 'Confirm',
    cancel: 'Cancel',
    copy: 'Copy',
    paste: 'Paste',
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      inactive: 'Disabled'
    }
  },

  // Email Configuration
  emailConfig: {
    // Search form
    search: {
      name: 'Configuration Name',
      namePlaceholder: 'Enter configuration name',
      purpose: 'Mail purpose',
      purposePlaceholder: 'Select purpose',
      category: 'Category',
      categoryPlaceholder: 'Select category',
      all: 'All',
      senderName: 'Sender Name',
      senderNamePlaceholder: 'Enter sender name',
      senderEmail: 'Sender Email',
      senderEmailPlaceholder: 'Enter sender email',
      smtpServer: 'SMTP Server',
      smtpServerPlaceholder: 'Enter SMTP server',
      searchButton: 'Search',
      resetButton: 'Reset',
      createButton: 'Create Configuration'
    },

    // Table columns
    table: {
      name: 'Configuration Name',
      purpose: 'Mail purpose',
      category: 'Category',
      senderName: 'Sender Name',
      senderEmail: 'Sender Email',
      smtpServer: 'SMTP Server',
      encryption: 'Encryption',
      testStatus: 'Test Status',
      ifDefault: 'Default',
      actions: 'Actions',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      setDefault: 'Set as Default',
      testEmail: 'Test Email',
      testConfig: 'Test Configuration',
      yes: 'Yes',
      no: 'No',
      encryptionNone: 'None',
      encryptionSSL: 'SSL',
      encryptionTLS: 'TLS',
      testStatusUntested: 'Untested',
      testStatusPassed: 'Passed',
      testStatusFailed: 'Failed'
    },

    // Form
    form: {
      title: {
        create: 'Create Email Configuration',
        edit: 'Edit Email Configuration',
        view: 'View Email Configuration'
      },
      name: 'Configuration Name',
      namePlaceholder: 'Enter configuration name',
      nameRequired: 'Please enter configuration name',
      nameMax: 'Configuration name cannot exceed 100 characters',
      purpose: 'Mail purpose',
      purposePlaceholder: 'Select mail purpose',
      purposeRequired: 'Please select mail purpose',
      category: 'Category',
      categoryPlaceholder: 'Select category',
      categoryRequired: 'Please select category',
      senderName: 'Sender Name',
      senderNamePlaceholder: 'Enter sender name',
      senderNameRequired: 'Please enter sender name',
      senderEmail: 'Sender Email',
      senderEmailPlaceholder: 'Enter sender email',
      senderEmailRequired: 'Please enter sender email',
      senderEmailInvalid: 'Please enter a valid email address',
      smtpServer: 'SMTP Server',
      smtpServerPlaceholder: 'Enter SMTP server address',
      smtpServerRequired: 'Please enter SMTP server address',
      smtpPort: 'SMTP Port',
      smtpPortPlaceholder: 'Enter SMTP port',
      smtpPortRequired: 'Please enter SMTP port',
      encryption: 'Encryption',
      encryptionPlaceholder: 'Select encryption method',
      smtpAccount: 'SMTP Account',
      smtpAccountPlaceholder: 'Enter SMTP account',
      smtpAccountRequired: 'Please enter SMTP account',
      smtpPassword: 'Authorization Code/SMTP Password',
      smtpPasswordPlaceholder: 'Enter authorization code/SMTP password',
      smtpPasswordRequired: 'Please enter authorization code/SMTP password',
      replyEmail: 'Reply Email',
      replyEmailPlaceholder: 'Enter reply email',
      replyEmailInvalid: 'Please enter a valid email address',
      enableSignature: 'Enable Signature',
      signature: 'Email Signature',
      signaturePlaceholder: 'Enter email signature',
      sendLimit: 'Single Send Quantity Limit',
      sendLimitPlaceholder: 'Enter single send quantity limit',
      sendLimitRequired: 'Please enter single send quantity limit',
      sendLimitTooltip: 'To avoid email account suspension from sending too many emails at once, it is recommended to set a reasonable limit based on your email service provider',
      ifDefault: 'Set as Default',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm',
      testButton: 'Test Configuration'
    },

    // Test configuration
    test: {
      resultTitle: 'Test Result',
      successMessage: 'Test Successful',
      failureMessage: 'Test Failed',
      closeButton: 'Close'
    },

    // Delete confirmation
    delete: {
      title: 'Delete Confirmation',
      message: 'Are you sure you want to delete the email configuration "{name}"?',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm'
    },

    // Messages
    messages: {
      createSuccess: 'Email configuration created successfully',
      createFailed: 'Failed to create email configuration',
      updateSuccess: 'Email configuration updated successfully',
      updateFailed: 'Failed to update email configuration',
      deleteSuccess: 'Email configuration deleted successfully',
      deleteFailed: 'Failed to delete email configuration',
      setDefaultSuccess: 'Set as default successfully',
      setDefaultFailed: 'Failed to set as default'
    },

    purposeTypes: {
      ALERT: 'Send alerts',
      AI_MARKETING: 'Send AI marketing',
      RECEIVE_BOOKING: 'Receive booking (B/L)',
      RECEIVE_SO: 'Receive SO'
    },
    categoryTypes: {
      '1': 'Alert center',
      '2': 'Business module'
    },
    meta: {
      purposeKeys: ['ALERT', 'AI_MARKETING', 'RECEIVE_BOOKING', 'RECEIVE_SO'],
      categoryValues: [1, 2]
    }
  },

  // Sent Emails
  sentEmails: {
    // Search form
    search: {
      subject: 'Subject',
      subjectPlaceholder: 'Enter email subject',
      recipients: 'Recipients',
      recipientsPlaceholder: 'Enter recipient email',
      operator: 'Operator',
      operatorPlaceholder: 'Select operator',
      status: 'Send Status',
      statusPlaceholder: 'Select send status',
      emailType: 'Email Type',
      emailTypePlaceholder: 'Select email type',
      sendTimeRange: 'Send Time',
      sendTimeRangePlaceholder: ['Start Time', 'End Time'],
      searchButton: 'Search',
      resetButton: 'Reset'
    },

    // Table columns
    table: {
      subject: 'Subject',
      recipients: 'Recipients',
      sendTime: 'Send Time',
      emailType: 'Email Type',
      operator: 'Operator',
      status: 'Send Status',
      recipientCount: 'Recipient Count',
      actions: 'Actions',
      view: 'View',
      delete: 'Delete',
      viewRecipients: 'View Recipients'
    },

    // Email types
    emailTypes: {
      developmentLetter: 'Development Letter',
      ratePromotion: 'Rate Promotion',
      systemNotification: 'System Notification'
    },

    // Send status
    status: {
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      returned: 'Returned'
    },

    // View details
    detail: {
      title: 'Email Details',
      emailBasicInfo: 'Email Basic Information',
      subject: 'Subject',
      emailType: 'Email Type',
      operator: 'Operator',
      sendTime: 'Send Time',
      status: 'Send Status',
      recipientCount: 'Recipient Count',
      recipients: 'Recipients',
      more: 'more',
      viewDetails: 'View Details',
      successCount: 'Success Count',
      failedCount: 'Failed Count',
      emailContent: 'Email Content',
      emailContentPreview: 'Email Content Preview',
      closeButton: 'Close'
    },

    // Recipient details modal
    recipientDetails: {
      title: 'Recipient Details',
      email: 'Recipient Email',
      total: 'Total {count} recipients',
      closeButton: 'Close'
    },

    // Recipient details
    recipients: {
      title: 'Recipient Details',
      searchPlaceholder: 'Search recipient email',
      email: 'Recipient Email',
      status: 'Send Status',
      sendTime: 'Send Time',
      errorReason: 'Error Reason',
      closeButton: 'Close',
      noData: 'No recipient information',
      statusSuccess: 'Success',
      statusFailed: 'Failed',
      statusPending: 'Pending'
    },

    // Delete confirmation
    delete: {
      title: 'Delete Confirmation',
      message: 'Are you sure you want to delete this email record?',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm'
    },

    // Messages
    messages: {
      deleteSuccess: 'Email record deleted successfully',
      deleteFailed: 'Failed to delete email record',
      noPermission: 'You do not have permission to delete email records'
    }
  },

  // Notification subscription page
  subscription: {
    actionBar: {
      copyTooltip: 'Copy all current settings',
      copyButton: 'Copy Settings',
      pasteTooltip: 'Paste copied settings to the selected role',
      pasteButton: 'Paste Settings',
      saveTooltip: 'Save subscription configuration for the current role',
      saveButton: 'Save',
      notificationConfig: 'Notification Configuration Management',
      operationManagement: 'Operation Management'
    },
    roles: {
      title: 'Notification Roles',
      searchPlaceholder: 'Search roles',
      empty: 'Please select a notification role first'
    },
    operations: {
      title: 'Operations',
      searchPlaceholder: 'Search operations',
      columnOperation: 'Operation',
      columnEmail: 'Email',
      columnWechat: 'WeCom',
      empty: 'Please select a notification role first'
    },
    subscribers: {
      title: 'Subscriber Roles',
      searchPlaceholder: 'Search roles',
      columnRole: 'Subscriber Role',
      columnEmail: 'Email',
      columnWechat: 'WeCom',
      emptyRole: 'Please select a notification role first',
      emptyOperation: 'Please select an operation'
    },
    tooltip: {
      missingTemplate:
        'This operation has no notification template configured and may fail to send notifications. Please create a template in Notification Template Settings.'
    },
    messages: {
      selectRoleFirst: 'Please select a notification role first',
      selectRoleAndOperation: 'Please select a notification role and operation first',
      selectAllOperations: 'Selected {count} operations',
      deselectOperations: 'Cleared {count} operations',
      selectAllSubscribers: 'Selected {count} subscriber roles',
      deselectSubscribers: 'Cleared {count} subscriber roles',
      copySuccess: 'Settings copied',
      pasteSuccess: 'Settings pasted',
      copyFirst: 'Please copy settings first',
      selectRoleToPaste: 'Please select a role to paste settings to',
      saveSuccess: 'Subscription configuration saved'
    }
  },

  // Notification template settings
  templateSettings: {
    tabs: {
      email: 'Email Templates',
      wechat: 'WeCom Templates',
      wechatWorkRpa: 'WeCom RPA Templates'
    },
    email: {
      filters: {
        templateCodePlaceholder: 'Template Code',
        operationPlaceholder: 'Trigger Operation',
        descriptionPlaceholder: 'Template Description',
        statusPlaceholder: 'Template Status',
        creatorPlaceholder: 'Creator'
      },
      buttons: {
        search: 'Search',
        reset: 'Reset',
        create: 'New Template'
      },
      table: {
        templateCode: 'Template Code',
        name: 'Template Name',
        operation: 'Trigger Operation',
        scenario: 'Email Scenario',
        channelConfig: 'Sender mailbox',
        description: 'Description',
        status: 'Status',
        creator: 'Creator',
        updatedAt: 'Last Updated',
        actions: 'Actions'
      },
      actions: {
        enable: 'Enable',
        disable: 'Disable',
        edit: 'Edit',
        preview: 'Preview',
        delete: 'Delete'
      },
      popconfirm: {
        delete: 'Are you sure you want to delete this email template?'
      },
      messages: {
        loadFailed: 'Failed to load email templates',
        toggle: 'Template {status}',
        toggleFailed: 'Failed to toggle template status',
        deleteLimited: 'Cannot delete the last template under the same operation',
        deleteSuccess: 'Template deleted successfully',
        deleteFailed: 'Failed to delete template'
      }
    },
    wechat: {
      filters: {
        idPlaceholder: 'Template ID',
        operationPlaceholder: 'Trigger Operation',
        templateTypePlaceholder: 'Template Type',
        statusPlaceholder: 'Template Status',
        creatorPlaceholder: 'Creator'
      },
      buttons: {
        search: 'Search',
        reset: 'Reset',
        create: 'New Template'
      },
      table: {
        id: 'Template ID',
        name: 'Template Name',
        operation: 'Trigger Operation',
        templateType: 'Template Type',
        description: 'Description',
        status: 'Status',
        creator: 'Creator',
        updatedAt: 'Last Updated',
        actions: 'Actions'
      },
      templateTypes: {
        text: 'Plain Text',
        card: 'Text Card',
        news: 'News',
        file: 'File'
      },
      actions: {
        enable: 'Enable',
        disable: 'Disable',
        edit: 'Edit',
        delete: 'Delete'
      },
      popconfirm: {
        delete: 'Are you sure you want to delete this WeCom template?'
      },
      messages: {
        loadFailed: 'Failed to load WeCom templates',
        toggle: 'Template {status}',
        toggleFailed: 'Failed to toggle template status',
        deleteLimited: 'Cannot delete the last template under the same operation',
        deleteSuccess: 'Template deleted successfully',
        deleteFailed: 'Failed to delete template'
      }
    },
    wechatWorkRpa: {
      filters: {
        idPlaceholder: 'Template ID',
        operationPlaceholder: 'Trigger Operation',
        templateTypePlaceholder: 'Template Type',
        statusPlaceholder: 'Template Status',
        creatorPlaceholder: 'Creator'
      },
      buttons: {
        search: 'Search',
        reset: 'Reset',
        create: 'New Template'
      },
      table: {
        id: 'Template ID',
        name: 'Template Name',
        operation: 'Trigger Operation',
        templateType: 'Template Type',
        description: 'Description',
        status: 'Status',
        creator: 'Creator',
        updatedAt: 'Last Updated',
        actions: 'Actions'
      },
      templateTypes: {
        text: 'Plain Text',
        card: 'Text Card',
        news: 'News',
        file: 'File'
      },
      actions: {
        enable: 'Enable',
        disable: 'Disable',
        edit: 'Edit',
        send: 'Send',
        preview: 'Preview',
        delete: 'Delete'
      },
      popconfirm: {
        delete: 'Are you sure you want to delete this WeCom RPA template?'
      },
      messages: {
        loadFailed: 'Failed to load WeCom RPA templates',
        toggle: 'Template {status}',
        toggleFailed: 'Failed to toggle template status',
        deleteLimited: 'Cannot delete the last template under the same operation',
        deleteSuccess: 'Template deleted successfully',
        deleteFailed: 'Failed to delete template'
      }
    }
  },

  // Operation management modal
  operationManagement: {
    title: 'Operation Management',
    filters: {
      idPlaceholder: 'Operation ID',
      sourcePlaceholder: 'Operation Source',
      statusPlaceholder: 'Status',
      statusAll: 'All',
      creatorPlaceholder: 'Creator'
    },
    listHeader: 'Operation List',
    buttons: {
      create: 'New Operation'
    },
    table: {
      id: 'Operation ID',
      source: 'Operation Source',
      status: 'Status',
      updater: 'Updated By',
      updatedAt: 'Last Updated',
      remark: 'Remark',
      actions: 'Actions',
      actionName: 'Operation Name',
      enabledStatus: 'Status',
      enabledVariables: 'Associated Variables',
      actionDescription: 'Description',
      variablesCount: '{count} variables',
      allVariables: 'All variables'
    },
    actions: {
      edit: 'Edit',
      enable: 'Enable',
      disable: 'Disable',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this operation?'
    },
    messages: {
      toggle: 'Operation {status}',
      deleteLast: 'Cannot delete the last operation',
      deleteSuccess: 'Operation deleted successfully'
    }
  },

  // Operation form modal
  operationForm: {
    title: {
      create: 'Create Operation',
      edit: 'Edit Operation'
    },
    fields: {
      source: {
        label: 'Operation Source',
        placeholder: 'Select operation source',
        required: 'Please select operation source'
      },
      status: {
        label: 'Status',
        placeholder: 'Select status',
        required: 'Please select status'
      },
      variables: {
        label: 'Associated Variables',
        placeholder: 'Select variables',
        hint: 'Select at least one variable',
        required: 'Please select at least one associated variable'
      },
      remark: {
        label: 'Remark',
        placeholder: 'Enter remark information'
      }
    },
    variables: {
      operatorName: 'Operator Name',
      operatorEmail: 'Operator Email',
      operationTime: 'Operation Time',
      inquiryNo: 'Inquiry Number',
      inquiryCustomer: 'Inquiry Customer',
      quotationNo: 'Quotation Number',
      quotationAmount: 'Quotation Amount',
      orderNo: 'Order Number',
      orderAmount: 'Order Amount'
    },
    variableTypes: {
      string: 'string',
      float: 'float',
      datetime: 'datetime'
    },
    messages: {
      createSuccess: 'Operation created successfully',
      updateSuccess: 'Operation updated successfully'
    }
  },

  // Email template form modal
  emailTemplateForm: {
    title: {
      create: 'Create Email Template',
      edit: 'Edit Email Template'
    },
    fields: {
      templateName: {
        label: 'Template Name',
        placeholder: 'Enter template name',
        required: 'Please enter template name',
        max: 'Template name is too long'
      },
      operation: {
        label: 'Trigger Operation',
        placeholder: 'Select trigger operation',
        required: 'Please select trigger operation'
      },
      emailScenario: {
        label: 'Email Scenario',
        placeholder: 'Select email scenario',
        required: 'Please select email scenario'
      },
      channelConfig: {
        label: 'Sender mailbox',
        placeholder: 'Select email channel configuration',
        required: 'Please select sender mailbox'
      },
      description: {
        label: 'Template Description',
        placeholder: 'Enter template description'
      },
      subject: {
        label: 'Email Subject',
        placeholder: 'Enter email subject',
        required: 'Please enter email subject',
        max: 'Email subject is too long'
      },
      content: {
        label: 'Email Content',
        placeholder: 'Enter email content (HTML supported)',
        required: 'Please enter email content'
      },
      footer: {
        label: 'Footer Signature',
        placeholder: 'Enter footer signature'
      },
      redirectLink: {
        label: 'Redirect Link',
        placeholder: 'Enter redirect link',
        invalid: 'Redirect link must be a valid URL'
      }
    },
    messages: {
      createSuccess: 'Email template created successfully',
      updateSuccess: 'Email template updated successfully',
      saveFailed: 'Failed to save email template'
    },
    scenarios: {
      COMMERCIAL_INVOICE_DRAFT: 'Commercial Invoice — Draft Email',
      COMMERCIAL_INVOICE_ORIGINAL: 'Commercial Invoice — Original Email',
      COMMERCIAL_INVOICE_ISF: 'Commercial Invoice — ISF',
      COMMERCIAL_INVOICE_CONTAINER_DETAIL: 'Commercial Invoice — Container Detail Invoice',
      LOADING_PLAN_DISPATCH: 'Loading Plan — Truck Dispatch',
      SUPPLEMENT_SUPPLIER: 'Supplement — Email to Supplier',
      BIDDING_SE: 'Bidding — Ocean Freight',
      BIDDING_TC: 'Bidding — Trucking',
      WINNING_SE: 'Award — Ocean Freight',
      WINNING_TC: 'Award — Trucking',
      BOOKING_EMAIL: 'Email Booking',
      TRACKING_EXCEPTION_ALERT: 'Tracking Exception Alert',
      OMS_DELIVERY_ORDER_BLOCKED: 'OMS Delivery Push Blocked',
      SHOKZ_SPACE_INQUIRY_CONFIRM: 'Space Inquiry Confirmation',
      SHOKZ_CONSIGNMENT_SUPPLIER_CONFIRM: 'Consignment Supplier Confirmation'
    },
    scenarioKeys: [
      'COMMERCIAL_INVOICE_DRAFT',
      'COMMERCIAL_INVOICE_ORIGINAL',
      'COMMERCIAL_INVOICE_ISF',
      'COMMERCIAL_INVOICE_CONTAINER_DETAIL',
      'LOADING_PLAN_DISPATCH',
      'SUPPLEMENT_SUPPLIER',
      'BIDDING_SE',
      'BIDDING_TC',
      'WINNING_SE',
      'WINNING_TC',
      'BOOKING_EMAIL',
      'TRACKING_EXCEPTION_ALERT',
      'OMS_DELIVERY_ORDER_BLOCKED',
      'SHOKZ_SPACE_INQUIRY_CONFIRM',
      'SHOKZ_CONSIGNMENT_SUPPLIER_CONFIRM'
    ],
    attachWithEmailOptions: [
      { value: '认证证书', label: 'Certification' },
      { value: '认证报告', label: 'Certification report' },
      { value: '运输鉴定报告', label: 'Transport identification report' },
      { value: '化学环保报告', label: 'Chemical & environmental report' },
      { value: '生物致敏报告', label: 'Biological sensitization report' },
      { value: '电池报告', label: 'Battery report' },
      { value: '放行条', label: 'Release slip' },
      { value: '提单草单', label: 'Draft bill of lading' },
      { value: '提单正本', label: 'Original bill of lading' },
      { value: '电放保函', label: 'Telex release letter' },
      { value: '报关单', label: 'Customs declaration' },
      { value: '放行通知书', label: 'Customs release notice' },
      { value: '报关底单', label: 'Customs declaration copy' },
      { value: '预税单', label: 'Pre-tax document' },
      { value: '税金单', label: 'Tax invoice' },
      { value: '正式税单', label: 'Official tax document' },
      { value: '约仓邮件', label: 'Slot booking email' },
      { value: 'POD', label: 'POD' }
    ],
    generateAttachmentOptions: [
      { value: '发货通知单', label: 'Shipping notice' },
      { value: '付款申请单', label: 'Payment application' },
      { value: '商业发票', label: 'Commercial invoice' }
    ]
  },

  // Email preview modal
  emailPreview: {
    title: 'Email Template Preview',
    viewDetail: 'View Details',
    empty: 'No email content yet'
  },

  // WeCom RPA preview modal
  wechatWorkRpaPreview: {
    title: 'WeCom RPA Message Preview',
    templateName: 'Template Name',
    templateDescription: 'Template Description',
    messageContent: 'Message Content',
    close: 'Close',
    empty: 'No message content yet'
  },

  // Notification configuration modal
  notificationConfigModal: {
    title: 'Notification Configuration Management',
    tabs: {
      email: 'Email',
      wechat: 'WeCom'
    },
    email: {
      configName: 'Configuration Name',
      configNamePlaceholder: 'Enter configuration name',
      senderName: 'Sender Name',
      senderNamePlaceholder: 'Enter sender name',
      senderEmail: 'Sender Email',
      senderEmailPlaceholder: 'Enter sender email',
      replyEmail: 'Reply Email',
      replyEmailPlaceholder: 'Reply email cannot be set',
      smtpServer: 'SMTP Server',
      smtpServerPlaceholder: 'Enter SMTP server address',
      port: 'Port',
      portPlaceholder: 'Enter port number',
      encryption: 'Encryption',
      smtpAccount: 'SMTP Account',
      smtpAccountPlaceholder: 'Enter SMTP account',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      description: 'Description',
      descriptionPlaceholder: 'Enter configuration description',
      isDefault: 'Default',
      defaultPlaceholder: 'Select whether it is default'
    },
    wechat: {
      configName: 'Configuration Name',
      configNamePlaceholder: 'Enter configuration name',
      corpId: 'Corp ID',
      corpIdPlaceholder: 'Enter Corp ID',
      agentId: 'Agent ID',
      agentIdPlaceholder: 'Enter Agent ID',
      apiSecret: 'API Secret',
      apiSecretPlaceholder: 'Enter API Secret',
      status: 'Status',
      statusPlaceholder: 'Select status',
      isDefault: 'Default',
      remark: 'Remark',
      remarkPlaceholder: 'Enter remark'
    },
    messages: {
      saved: 'Notification configuration saved'
    },
    test: {
      button: 'Test Connection',
      success: 'Test Successful',
      failure: 'Test Failed'
    }
  },

  // Variable selector
  variableSelector: {
    searchPlaceholder: 'Search variables',
    empty: 'No matching variables',
    button: 'Insert Variable'
  },

  // WeCom template form
  wechatTemplateForm: {
    title: {
      create: 'Create WeCom Template',
      edit: 'Edit WeCom Template'
    },
    fields: {
      operation: {
        label: 'Trigger Operation',
        placeholder: 'Select trigger operation',
        required: 'Trigger operation is required'
      },
      templateType: {
        label: 'Template Type',
        placeholder: 'Select template type',
        required: 'Template type is required'
      },
      description: {
        label: 'Template Description',
        placeholder: 'Enter template description'
      },
      textContent: {
        label: 'Text Content',
        placeholder: 'Enter text content',
        required: 'Text content is required',
        max: 'Text content is too long'
      },
      safe: {
        label: 'Confidential Message',
        options: {
          no: 'No',
          yes: 'Yes'
        }
      },
      title: {
        label: 'Title',
        placeholder: 'Enter title',
        required: 'Title is required',
        max: 'Title is too long'
      },
      cardDescription: {
        label: 'Description',
        placeholder: 'Enter description',
        required: 'Description is required',
        max: 'Description is too long'
      },
      link: {
        label: 'Link',
        placeholder: 'Enter link',
        required: 'Link is required',
        invalid: 'Link must be a valid URL'
      },
      buttonText: {
        label: 'Button Text',
        placeholder: 'Enter button text'
      },
      newsDescription: {
        label: 'Description',
        placeholder: 'Enter description',
        required: 'Description is required',
        max: 'Description is too long'
      },
      imageUrl: {
        label: 'Image URL',
        placeholder: 'Enter image URL'
      },
      file: {
        label: 'File Upload',
        button: 'Upload File'
      }
    },
    templateTypes: {
      text: 'Plain Text',
      card: 'Text Card',
      news: 'News',
      file: 'File'
    },
    messages: {
      createSuccess: 'WeCom template created successfully',
      updateSuccess: 'WeCom template updated successfully',
      saveFailed: 'Failed to save WeCom template'
    }
  },

  // WeCom Configuration
  wechatConfig: {
    // Search form
    search: {
      name: 'Configuration Name',
      namePlaceholder: 'Enter configuration name',
      corpId: 'Corp ID',
      corpIdPlaceholder: 'Enter Corp ID',
      agentId: 'Agent ID',
      agentIdPlaceholder: 'Enter Agent ID',
      searchButton: 'Search',
      resetButton: 'Reset',
      createButton: 'Create Configuration'
    },

    // Table columns
    table: {
      name: 'Configuration Name',
      corpId: 'Corp ID',
      agentId: 'Agent ID',
      status: 'Status',
      testStatus: 'Test Status',
      ifDefault: 'Default',
      actions: 'Actions',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      setDefault: 'Set as Default',
      testWechat: 'Test WeCom',
      yes: 'Yes',
      no: 'No',
      statusEnabled: 'Enabled',
      statusDisabled: 'Disabled',
      testStatusUntested: 'Untested',
      testStatusPassed: 'Passed',
      testStatusFailed: 'Failed'
    },

    // Form
    form: {
      title: {
        create: 'Create WeCom Configuration',
        edit: 'Edit WeCom Configuration',
        view: 'View WeCom Configuration'
      },
      name: 'Configuration Name',
      namePlaceholder: 'Enter configuration name',
      nameRequired: 'Please enter configuration name',
      nameMax: 'Configuration name cannot exceed 100 characters',
      description: 'Description',
      descriptionPlaceholder: 'Enter description',
      descriptionMax: 'Description cannot exceed 500 characters',
      corpId: 'Corp ID',
      corpIdPlaceholder: 'Enter Corp ID',
      corpIdRequired: 'Please enter Corp ID',
      agentId: 'Agent ID',
      agentIdPlaceholder: 'Enter Agent ID',
      agentIdRequired: 'Please enter Agent ID',
      secret: 'App Secret',
      secretPlaceholder: 'Enter App Secret',
      secretRequired: 'Please enter App Secret',
      ifDefault: 'Set as Default',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm'
    },

    // Test configuration
    test: {
      resultTitle: 'Test Result',
      successMessage: 'Test Successful',
      failureMessage: 'Test Failed',
      closeButton: 'Close'
    },

    // Delete confirmation
    delete: {
      title: 'Delete Confirmation',
      message: 'Are you sure you want to delete the WeCom configuration "{name}"?',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm'
    },

    // Messages
    messages: {
      createSuccess: 'WeCom configuration created successfully',
      createFailed: 'Failed to create WeCom configuration',
      updateSuccess: 'WeCom configuration updated successfully',
      updateFailed: 'Failed to update WeCom configuration',
      deleteSuccess: 'WeCom configuration deleted successfully',
      deleteFailed: 'Failed to delete WeCom configuration',
      setDefaultSuccess: 'Set as default successfully',
      setDefaultFailed: 'Failed to set as default'
    }
  },

  // WeCom API configuration page (keep old structure for compatibility)
  wechatWorkConfig: {
    filters: {
      namePlaceholder: 'Configuration Name',
      corpIdPlaceholder: 'Corp ID',
      agentIdPlaceholder: 'Agent ID',
      statusPlaceholder: 'Status'
    },
    buttons: {
      search: 'Search',
      reset: 'Reset',
      create: 'New Configuration'
    },
    table: {
      name: 'Configuration Name',
      corpId: 'Corp ID',
      agentId: 'Agent ID',
      status: 'Status',
      isDefault: 'Default',
      remark: 'Remark',
      actions: 'Actions'
    },
    actions: {
      view: 'View',
      edit: 'Edit',
      setDefault: 'Set as Default',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this WeCom API configuration?'
    },
    detail: {
      title: 'WeCom API Configuration Details',
      name: 'Configuration Name',
      status: 'Status',
      corpId: 'Corp ID',
      agentId: 'Agent ID',
      secret: 'App Secret',
      isDefault: 'Default',
      remark: 'Remark',
      createdAt: 'Created At',
      updatedAt: 'Updated At'
    },
    form: {
      title: {
        create: 'Create WeCom API Configuration',
        edit: 'Edit WeCom API Configuration'
      },
      name: {
        label: 'Configuration Name',
        placeholder: 'Enter configuration name',
        required: 'Please enter configuration name',
        max: 'Configuration name cannot exceed 50 characters'
      },
      corpId: {
        label: 'Corp ID',
        placeholder: 'Enter Corp ID',
        required: 'Please enter Corp ID'
      },
      agentId: {
        label: 'Agent ID',
        placeholder: 'Enter Agent ID',
        required: 'Please enter Agent ID'
      },
      secret: {
        label: 'App Secret',
        placeholder: 'Enter App Secret',
        required: 'Please enter App Secret'
      },
      status: {
        label: 'Status',
        placeholder: 'Select status',
        required: 'Please select status'
      },
      remark: {
        label: 'Remark',
        placeholder: 'Enter remark (max 200 characters)'
      },
      test: {
        button: 'Test Connection',
        success: 'Test Successful',
        failure: 'Test Failed',
        pending: 'Testing...',
        fillFirst: 'Please complete the configuration information first'
      }
    },
    messages: {
      deleteSuccess: 'Configuration deleted successfully',
      setDefaultSuccess: 'Default configuration updated',
      testSuccess: 'Connection test successful',
      testFailure: 'Connection test failed',
      notTested: 'This configuration has not passed the test yet',
      createSuccess: 'Configuration created successfully',
      updateSuccess: 'Configuration updated successfully'
    }
  },

  // WeCom RPA Configuration
  wechatWorkRpaConfig: {
    // Search form
    search: {
      name: 'Config Name',
      namePlaceholder: 'Please enter config name',
      searchButton: 'Search',
      resetButton: 'Reset',
      createButton: 'New Config'
    },

    // Table columns
    table: {
      name: 'Config Name',
      status: 'Status',
      testStatus: 'Test Status',
      ifDefault: 'Default Config',
      actions: 'Actions',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      setDefault: 'Set Default',
      testRpa: 'Test RPA',
      yes: 'Yes',
      no: 'No',
      statusEnabled: 'Enabled',
      statusDisabled: 'Disabled',
      testStatusUntested: 'Untested',
      testStatusPassed: 'Test Passed',
      testStatusFailed: 'Test Failed'
    },

    // Form
    form: {
      title: {
        create: 'New WeCom RPA Config',
        edit: 'Edit WeCom RPA Config',
        view: 'View WeCom RPA Config'
      },
      name: 'Config Name',
      namePlaceholder: 'Please enter config name',
      nameRequired: 'Please enter config name',
      nameMax: 'Config name cannot exceed 100 characters',
      description: 'Description',
      descriptionPlaceholder: 'Please enter description',
      descriptionMax: 'Description cannot exceed 500 characters',
      secret: 'App Secret',
      secretPlaceholder: 'Please enter app secret',
      secretRequired: 'Please enter app secret',
      ifDefault: 'Set as default config',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm'
    },

    // Test Config
    test: {
      resultTitle: 'Test Result',
      successMessage: 'Test Successful',
      failureMessage: 'Test Failed',
      closeButton: 'Close'
    },

    // Delete Confirmation
    delete: {
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete WeCom RPA config "{name}"?',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm'
    },

    // Messages
    messages: {
      createSuccess: 'WeCom RPA config created successfully',
      createFailed: 'Failed to create WeCom RPA config',
      updateSuccess: 'WeCom RPA config updated successfully',
      updateFailed: 'Failed to update WeCom RPA config',
      deleteSuccess: 'WeCom RPA config deleted successfully',
      deleteFailed: 'Failed to delete WeCom RPA config',
      setDefaultSuccess: 'Set as default config successfully',
      setDefaultFailed: 'Failed to set default config'
    }
  }
}
